// Utils
import { isMultiSelectListItemSelected } from 'SecurityListsApp/ts/features/security-list-selector-modals/components/multi-select-list/utils/multi-select-list-utils';
import * as i0 from "@angular/core";
/**
 * Is Multi Select Sub List Item Selected Pipe
 *
 * Checks if a sub list item of a multi select list item is selected.
 */
export class isMultiSelectSubListItemLevelsSelectedPipe {
    transform(item, selectedItems, activeSecurityGroupTab) {
        if (item.sub_list) {
            const selectedSubItems = item.sub_list.filter((subItem) => isMultiSelectListItemSelected(subItem, selectedItems, activeSecurityGroupTab));
            const selectedItem = isMultiSelectListItemSelected(item, selectedItems, activeSecurityGroupTab);
            return selectedSubItems.length > 0 || selectedItem;
        }
        return false;
    }
}
isMultiSelectSubListItemLevelsSelectedPipe.ɵfac = function isMultiSelectSubListItemLevelsSelectedPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || isMultiSelectSubListItemLevelsSelectedPipe)(); };
isMultiSelectSubListItemLevelsSelectedPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "isMultiSelectSubListLevelsItemSelected", type: isMultiSelectSubListItemLevelsSelectedPipe, pure: true, standalone: false });
